import React from "react";
import MarketPageSection from "../sections/MarketPageSection/Content";
const MarketPage = () => {
  return <MarketPageSection />;
};

export default MarketPage;
